export const RiApplicationTableColumnIds = {
  PropertyName: 'propertyName',
  BuildingUnit: 'buildingUnit',
  Renter: 'renter',
  PolicyStatus: 'policyStatus',
  ComplianceStatus: 'complianceStatus',
  Source: 'source',
  UpdatedAt: 'updatedAt',
} as const;
